import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PrecheckStatus } from '@core/dto/precheck/PrecheckStatus';
import { PrecheckSummary } from '@core/dto/precheck/PrecheckSummary';
import { LocaleService } from '@core/service/locale.service';
import { Currency } from '@core/dto/CurrencyCode';

@Component({
  selector: 'app-view-precheck-no',
  templateUrl: './view-precheck-no.component.html',
  styleUrls: ['./view-precheck-no.component.scss'],
})
export class ViewPrecheckNoComponent implements OnInit {
  @Input() precheck: PrecheckSummary;

  @Output() resendSms = new EventEmitter<PrecheckSummary>();

  PrecheckStatus = PrecheckStatus;

  constructor(public localeService: LocaleService) {}

  ngOnInit(): void {}

  resend() {
    this.resendSms.emit(this.precheck);
  }

  showAmount(): boolean {
    return (
      this.precheck.status === PrecheckStatus.PENDING ||
      this.precheck.status === PrecheckStatus.CANCELLED
    );
  }

  getCurrencySymbol(currencyCode: string): string {
    const symbols: Record<string, string> = {
      NOK: 'kr',
      SEK: 'kr',
      EUR: '€',
    };
    return symbols[currencyCode] || currencyCode;
  }

  formatCurrency(currency: Currency): string {
    return new Intl.NumberFormat('no-NO', {
      style: 'currency',
      currency: currency.currencyCode,
    }).format(currency.amount);
  }

  formatDecimal(value: string): string {
    return value.replace('.', ',');
  }

  iconColor(): string {
    if (this.precheck.status === PrecheckStatus.CANCELLED) {
      return '#6a7381';
    } else {
      return '#0A1018';
    }
  }
}
